export const appConfig = {
    url: ENVIRONMENT.url,
    appUrl: ENVIRONMENT.appUrl,
    mobileMaxWidth: 576,
    smallTabletMaxWidth: 768,
    tabletMaxWidth: 1024,
    prepurchaseAccountInfoId: 'txr-prepurchase-account-info',
    prepurchaseIdKey: 'txr-prepurchase-id-key',
    referralPartnerIdKey: 'txr-referral-pattner-id-key',
    
    hubspotPortalId: ENVIRONMENT.hubspotPortalId,
    hubspotSignupFormId: ENVIRONMENT.hubspotSignupFormId,
    hubspotFreeTrialFormId: ENVIRONMENT.hubspotFreeTrialFormId,
    hubspotCheckNumberFormId: ENVIRONMENT.hubspotCheckNumberFormId,
    hubspotContactUsFormId: ENVIRONMENT.hubspotContactUsFormId,
    hubspotFormSubmissionFormId: ENVIRONMENT.hubspotFormSubmissionFormId,

    hubspotV2PortalId: ENVIRONMENT.hubspotV2PortalId,
    hubspotV2FreeTrialRequestFormId:  ENVIRONMENT.hubspotV2FreeTrialRequestFormId,
};

